import { HelpService } from './../../../../shared/services/help/help.service';
import { OpenDialogAddEditHelpComponent } from './../../../dialog/open-dialog-add-edit-help/open-dialog-add-edit-help.component';
import { Component, Input, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DatatableBaseComponent } from 'app/shared/components/datatable-base.component';
import { Federation, Licence } from 'app/shared/models/class/federation/federation';
import { Help } from 'app/shared/models/class/help/help';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { AdminHelpComponent } from '../admin-help.component';

@Component({
  selector: 'app-admin-sub-video-help',
  templateUrl: './admin-sub-video-help.component.html',
  styleUrls: ['./admin-sub-video-help.component.scss']
})
export class AdminSubVideoHelpComponent extends DatatableBaseComponent implements OnInit {

  title: string;

  @Input() subVideoHelp: Help[];
  @Input() help: Help;
  dataSource: MatTableDataSource<Help>;

  displayedColumns = ['title', 'description', 'videoName', 'actions'];

  isLoading = false;


  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  constructor(
    protected uiSrv: UiService,
    private faIconService: FaiconService,
    private tooltipSrv: TooltipService,
    private dialog: MatDialog,
    private helpComponent: AdminHelpComponent,
    private helpSrv: HelpService
  ) {
    super(uiSrv);
  }

  ngOnInit(): void {
    this.initTable();
  }

  private initTable(): void {
    if (this.subVideoHelp) {
      this.dataSource = new MatTableDataSource(this.subVideoHelp);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.length = this.subVideoHelp.length;
      this.isLoading = false;
    }

  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getTooltip(value: string): string {
    return this.tooltipSrv.getTooltip(value);
  }

  openDialogAddEditHelp(actionDialog: string, motherHelp: Help, help?: Help): void {

    const dialogRef = this.dialog.open(OpenDialogAddEditHelpComponent, {
      data: { action: actionDialog, motherHelp: motherHelp, help: help || null },
      height: '375px',
      width: '600px'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {res ? this.helpComponent.gethelps(): null}
    });
  }

  deleteHelp(help) {
    const confirmation = confirm("Êtes-vous certain de supprimer cette aide vidéo ?");
    if (confirmation) {
      this.helpSrv.delete(help).subscribe(() => {
        this.uiSrv.showSnackbar('Aide vidéo supprimée avec succès');
        this.helpComponent.gethelps();
      });
    }
  }
}
